import { render, staticRenderFns } from "./DatatableSearchAction.vue?vue&type=template&id=2b2dc5ec&v-slot%3Atop=true&"
import script from "./DatatableSearchAction.vue?vue&type=script&lang=js&"
export * from "./DatatableSearchAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports